<template>
  <div>
    <v-list dense>
      <v-list-item
        v-for="item in menu"
        :key="item.title"
        :to="item.link" exact
        >
        <v-list-item-action>
          <v-icon :color="item.color">{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>{{ item.title }}</v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  data () {
    return {
      menu: [
        { icon: 'mdi-home', title: 'Accueil', link: { name: 'home' }, color: 'black' },
        { icon: 'mdi-qrcode', title: 'Scan Qr Code', link: { name: 'scan' }, color: 'black' }
      ]
    }
  },
  methods: {
  },
  created () {
  }
}
</script>

<style>
</style>
